<template>
    <div class="template-generator-divider">
        <div class="divider"></div>
    </div>
</template>

<script>
export default {
   
}
</script>

<style>
.template-generator-divider{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.template-generator-divider .divider{
    height: 1px;
    width: 100%;
    background-color: rgba(0, 0, 0,0.3);
}
</style>